import zhHans from './zhHans.json'
import en from './en.json'
import Vue from 'vue'
import VueI18n from 'vue-i18n'
Vue.use(VueI18n)

export const getLang = () => window.localStorage.getItem('lang') || 'en'
const messages = {
  zhHans,
  en
}
export const lang = getLang()
export const i18n = new VueI18n({
  locale: lang,
  messages
})



// WEBPACK FOOTER //
// ./src/i18n/index.js